<script>
  import {External, M} from "../external";

  export let data, selection, tableType, onOrder, hasSelection;

  let columnCache = {},
    order = {};

  function render(column) {
    let cache = columnCache[column];
    let property = cache || External.getById(External.Website.crmProperties, column);

    if (!cache && property) {
      columnCache[column] = property;
    }

    if (property) {
      return {
        clz: column === -1 || column === -2 ? "flex-1" : "flex-none", // name & email are with flex-1
        property: property
      };
    }

    return null;
  }

  function onSelect(e) {
    let checked = e.target.checked;

    if (checked) {
      selection = Object.assign(
        {},
        {
          all: true,
          selected: [],
          unselected: []
        },
        {}
      );
    } else {
      selection = null;
    }
  }

  function onOrderClick(column) {
    let dir;
	if (!column.sortable) {
	  return;
	}
    if (order.column === column) {
      if (order.dir !== "") {
        if (order.dir.indexOf("asc") !== -1) {
          dir = "desc";
        } else {
          dir = "";
        }
      } else {
        dir = "asc";
      }
    } else {
      dir = "asc";
    }

    order = Object.assign({}, order, { column: column, dir: dir, clz: dir !== "" ? "order-column " + dir : "" });
    onOrder(order.dir !== "" ? order : null);
  }
</script>

<tr class="flex flex-row align-center" style="padding-bottom: 0;">
  {#if hasSelection}
    <th class="checkbox-table">
      <div class="checkbox-wrapper small">
        <input id="rowcbx0" class="css-checkbox select-cbx" type="checkbox" name="rowcbx0" on:change={onSelect} />
        <label for="rowcbx0" class="css-label">&nbsp;</label>
      </div>
    </th>
  {/if}
  {#if tableType !== "contacts"}
    {#each data as column (column)}
      {#if column.type === "action"}
        <th class={column.class}>&nbsp;</th>
      {:else}
        <th class={column.class}>
          <a class={order.column === column ? order.clz : ""} on:click={() => onOrderClick(column)}>{column.label}</a>
        </th>
      {/if}
    {/each}
  {:else if data != null && data.length > 0}
    {#each data as column}
      {#if column === "created"}
        <th class="flex-none"><a rel="action" class={order.column === "created" ? order.clz : ""} on:click={() => onOrderClick("created")} data-order="created">{M.CREATED}</a></th>
      {:else if column === "registered"}
        <th class="flex-none"
          ><a rel="action" class={order.column === "registered" ? order.clz : ""} on:click={() => onOrderClick("registered")} data-order="registered">{M.REGISTERED_ON}</a>
        </th>
      {:else if column === "status"}
        <th class="flex-none"><a rel="action" class={order.column === "status" ? order.clz : ""} on:click={() => onOrderClick("status")} data-order="status">{M.STATUS}</a> </th>
      {:else if column === "tags"}
        <th class="flex-none">{M.TAGS}</th>
      {:else if render(column) != null}
        <th class={render(column).clz}>
          <a rel="action" class={order.column === column ? order.clz : ""} on:click={() => onOrderClick(column)} data-order={column}>{render(column).property.label}</a>
        </th>
      {/if}
    {/each}
  {/if}
</tr>
